// extracted by mini-css-extract-plugin
export default {"picture":"yVnIO_FTYC5hUyhz0Vbc"};